module.exports = "/images/logo-zoho.svg?dc3d5ad9eb2cc780edf85dde1ad40ab6";